// apps/admin-ui/src/features/coin-transactions/reason-badge.tsx
import type { CoinTxReason } from '@upme/contracts';
import { Badge } from '@upme/ui/components/badge';

export const REASON_LABEL: Record<CoinTxReason, string> = {
  REFERRAL_BONUS: 'Реферальный бонус',
  MANUAL_ADJUST: 'Ручная корректировка',
  ADVERT_POST: 'Реклама',
  PHOTO_TAG_BONUS: 'Отметка на фото',
  MISSION_REWARD: 'Награда за миссию',
  ENERGY_PURCHASE: 'Покупка энергии',
  ORGANIZER_INVITE_BONUS: 'Приглашение организатора',
  ORGANIZER_WELCOME_BONUS: 'Приветственный бонус',
  SERVICE_PUBLISH: 'Публикация услуги',
  SERVICE_PUBLISH_REFUND: 'Возврат за услугу',
  EVENT_PUBLISH: 'Публикация события',
  EVENT_PUBLISH_REFUND: 'Возврат за событие',
  PROMOTION_SOCIAL: 'Продвижение в соцсетях',
  PROMOTION_SOCIAL_REFUND: 'Возврат за продвижение',
  PROMOTION_MORNING_DIGEST: 'Слот в утренней рассылке',
  PROMOTION_MORNING_DIGEST_REFUND: 'Возврат за слот в рассылке',
  NETWORKING_SWIPE: 'Свайп в знакомствах',
  MEETING_FEED: 'Встреча в ленте',
  ASSISTANT_REQUEST: 'Запрос ассистенту',
  GAME_REQUEST: 'Игровое действие',
  LILO_REQUEST: 'Ход в игре Лило',
  LILO_SESSION: 'Партия в Лило',
  LILO_SESSION_REFUND: 'Возврат за партию в Лило',
  WELCOME_BONUS: 'Приветственный бонус (старт)',
  COMPATIBILITY_REQUEST: 'Совместимость (ИИ)',
  ASSISTANT_PERSON_REROLL: 'Перебор человека недели',
  PROMOTION_ADS: 'Реклама 25 000 показов',
  PROMOTION_ADS_REFUND: 'Возврат за рекламу',
  STATUS_ENERGY_GRANT: 'Энергия за Pro / Gold',
  RESERVATION_HOLD: 'Заморозка в резерв',
  RESERVATION_PAYOUT: 'Выплата из резерва',
  RESERVATION_RELEASE: 'Возврат из резерва',
};

// Цвет — outline + кастомный класс, потому что Badge тоны не поддерживает.
// Совпадает с подходом в import-queue-table (confidenceClass).
const REASON_CLASS: Record<CoinTxReason, string> = {
  REFERRAL_BONUS: 'border-emerald-500 text-emerald-700 dark:text-emerald-400',
  MANUAL_ADJUST: 'border-sky-500 text-sky-700 dark:text-sky-400',
  ADVERT_POST: 'border-violet-500 text-violet-700 dark:text-violet-400',
  PHOTO_TAG_BONUS: 'border-amber-500 text-amber-700 dark:text-amber-400',
  MISSION_REWARD: 'border-indigo-500 text-indigo-700 dark:text-indigo-400',
  ENERGY_PURCHASE: 'border-green-500 text-green-700 dark:text-green-400',
  ORGANIZER_INVITE_BONUS: 'border-teal-500 text-teal-700 dark:text-teal-400',
  ORGANIZER_WELCOME_BONUS: 'border-rose-500 text-rose-700 dark:text-rose-400',
  SERVICE_PUBLISH: 'border-orange-500 text-orange-700 dark:text-orange-400',
  SERVICE_PUBLISH_REFUND: 'border-lime-500 text-lime-700 dark:text-lime-400',
  EVENT_PUBLISH: 'border-cyan-500 text-cyan-700 dark:text-cyan-400',
  EVENT_PUBLISH_REFUND: 'border-fuchsia-500 text-fuchsia-700 dark:text-fuchsia-400',
  PROMOTION_SOCIAL: 'border-pink-500 text-pink-700 dark:text-pink-400',
  PROMOTION_SOCIAL_REFUND: 'border-slate-500 text-slate-700 dark:text-slate-400',
  PROMOTION_MORNING_DIGEST: 'border-amber-600 text-amber-800 dark:text-amber-300',
  PROMOTION_MORNING_DIGEST_REFUND: 'border-neutral-500 text-neutral-700 dark:text-neutral-400',
  NETWORKING_SWIPE: 'border-purple-500 text-purple-700 dark:text-purple-400',
  MEETING_FEED: 'border-yellow-500 text-yellow-700 dark:text-yellow-400',
  ASSISTANT_REQUEST: 'border-blue-500 text-blue-700 dark:text-blue-400',
  GAME_REQUEST: 'border-stone-500 text-stone-700 dark:text-stone-400',
  LILO_REQUEST: 'border-red-500 text-red-700 dark:text-red-400',
  LILO_SESSION: 'border-red-500 text-red-700 dark:text-red-400',
  LILO_SESSION_REFUND: 'border-emerald-500 text-emerald-700 dark:text-emerald-400',
  WELCOME_BONUS: 'border-emerald-500 text-emerald-700 dark:text-emerald-400',
  COMPATIBILITY_REQUEST: 'border-violet-600 text-violet-700 dark:text-violet-400',
  ASSISTANT_PERSON_REROLL: 'border-blue-600 text-blue-800 dark:text-blue-300',
  PROMOTION_ADS: 'border-orange-500 text-orange-700 dark:text-orange-400',
  PROMOTION_ADS_REFUND: 'border-emerald-500 text-emerald-700 dark:text-emerald-400',
  STATUS_ENERGY_GRANT: 'border-emerald-500 text-emerald-700 dark:text-emerald-400',
  RESERVATION_HOLD: 'border-sky-600 text-sky-800 dark:text-sky-300',
  RESERVATION_PAYOUT: 'border-green-600 text-green-800 dark:text-green-300',
  RESERVATION_RELEASE: 'border-teal-600 text-teal-800 dark:text-teal-300',
};

export function ReasonBadge({ reason }: { reason: CoinTxReason }) {
  return (
    <Badge variant="outline" className={REASON_CLASS[reason]}>
      {REASON_LABEL[reason]}
    </Badge>
  );
}
